import type { Entity } from '@backstage/catalog-model';

/** Grafana, where the platform's logs and dashboards are read (DX-358). */
export const GRAFANA = 'https://monitor.revenexx.com';

/**
 * The community Grafana plugin's annotation. Our convention holds one tag,
 * normally the component's name, so the page builds the link itself and never
 * asks Grafana.
 */
export const DASHBOARD_SELECTOR = 'grafana/dashboard-selector';

/** The Portainer stack a component runs as, which names its Docker logs. */
export const SWARM_STACK = 'revenexx.com/swarm-stack';

/** The provisioned *Logs — Service Drilldown* dashboard (PE-229). */
const LOGS_DASHBOARD = 'logs-service-drilldown';

export type Observability = {
  logs?: { stack: string; url: string };
  metrics?: { tag: string; url: string };
};

const valueOf = (entity: Entity, key: string) =>
  entity.metadata.annotations?.[key]?.trim() || undefined;

/**
 * Where a component's logs and dashboards are, from its two annotations. A
 * component that sets neither has neither, and the page shows no placeholder.
 */
export function observabilityOf(entity: Entity): Observability {
  const stack = valueOf(entity, SWARM_STACK);
  const tag = valueOf(entity, DASHBOARD_SELECTOR);
  return {
    ...(stack && {
      logs: {
        stack,
        // `$__all` stays literal: it is Grafana's own "every service".
        url: `${GRAFANA}/d/${LOGS_DASHBOARD}?var-stack=${encodeURIComponent(
          stack,
        )}&var-service=$__all`,
      },
    }),
    ...(tag && {
      metrics: {
        tag,
        url: `${GRAFANA}/dashboards?tag=${encodeURIComponent(tag)}`,
      },
    }),
  };
}
